export const PERMISSION_DENIED_LABEL: string =
  "Seu perfil não tem permissão para esta ação";

export const permissionDeniedLabel = (action: string): string =>
  `${action} — ${PERMISSION_DENIED_LABEL.toLowerCase()}`;
